import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import { action, computed, flow, observable } from "mobx";
import { Product, PaddleTransaction } from "../models";
import { RealCommerceError } from "../exceptions";
import { realCommerceRequest } from "../utils";
import { routeLocationCashbackClaimPost, routeLocationPaddleIncompleteCheckoutGet } from "@devowl-wp/api-real-commerce";
var CheckoutStep = /*#__PURE__*/function (CheckoutStep) {
  CheckoutStep[CheckoutStep["Scratch"] = 0] = "Scratch";
  CheckoutStep[CheckoutStep["ProductLoaded"] = 1] = "ProductLoaded";
  CheckoutStep[CheckoutStep["VendorLoaded"] = 2] = "VendorLoaded";
  CheckoutStep[CheckoutStep["AppliedIdentification"] = 3] = "AppliedIdentification";
  CheckoutStep[CheckoutStep["PaymentFrameLoaded"] = 4] = "PaymentFrameLoaded";
  CheckoutStep[CheckoutStep["AwaitingPayment"] = 5] = "AwaitingPayment";
  CheckoutStep[CheckoutStep["Paid"] = 6] = "Paid";
  CheckoutStep[CheckoutStep["NotYetProcessedButShowConfirmation"] = 7] = "NotYetProcessedButShowConfirmation";
  return CheckoutStep;
}(CheckoutStep || {});
let CheckoutStore = (_class = class CheckoutStore {
  get loading() {
    return this.step < CheckoutStep.VendorLoaded || this.busyRecover || this.busyCashbackClaim;
  }
  constructor(rootStore) {
    _initializerDefineProperty(this, "busyRecover", _descriptor, this);
    _initializerDefineProperty(this, "busyCashbackClaim", _descriptor2, this);
    _initializerDefineProperty(this, "step", _descriptor3, this);
    _initializerDefineProperty(this, "product", _descriptor4, this);
    _initializerDefineProperty(this, "transaction", _descriptor5, this);
    _initializerDefineProperty(this, "claimedCashback", _descriptor6, this);
    this.rootStore = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.startTransaction = flow(function* (params, recovered) {
      this.setStep(CheckoutStep.Scratch);
      this.product = yield Product.loadProduct(params, this);

      // Start product transaction (currently only Paddle is supported)
      const {
        name
      } = this.product.data.productPlan.product.ecommerceSystem;
      switch (name.toLowerCase()) {
        case "paddle":
          this.transaction = new PaddleTransaction(this.product, recovered);
          break;
        default:
          throw new Error(`${name} transactions not yet implemented.`);
      }
      this.setStep(CheckoutStep.ProductLoaded);

      // Load external vendor files
      yield this.transaction.loadVendorScripts();
      this.setStep(CheckoutStep.VendorLoaded);
    });
    /**
     * Recover incomplete checkout from a given UUID and automatically start the transaction.
     *
     * @param uuid
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.recoverIncompleteCheckout = flow(function* (uuid) {
      this.busyRecover = true;
      try {
        const result = yield realCommerceRequest({
          location: routeLocationPaddleIncompleteCheckoutGet,
          params: {
            uuid
          }
        });

        // Start transaction with the known product
        const {
          checkout: {
            product: {
              id: productId
            },
            productPlan: {
              id: productPlanId
            },
            currency
          }
        } = result;
        this.startTransaction({
          productId,
          productPlanId,
          currency
        }, result);
      } catch (e) {
        throw new RealCommerceError(e);
      } finally {
        this.busyRecover = false;
      }
    });
    /**
     * Claim cashback.
     *
     * @param uuid
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.claimCashback = flow(function* (cashbackToken) {
      this.busyCashbackClaim = true;
      try {
        const {
          checkout: {
            cashbackPromotion
          }
        } = yield realCommerceRequest({
          location: routeLocationCashbackClaimPost,
          request: {
            checkout: {
              cashbackToken
            }
          }
        });
        this.claimedCashback = cashbackPromotion;
      } catch (e) {
        this.claimedCashback = new RealCommerceError(e);
      } finally {
        this.busyCashbackClaim = false;
      }
    });
    this.rootStore = rootStore;
  }
  setStep(step) {
    this.step = step;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "busyRecover", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busyCashbackClaim", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "step", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return CheckoutStep.Scratch;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "product", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "transaction", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "claimedCashback", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "loading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setStep"), _class.prototype)), _class);
export { CheckoutStore, CheckoutStep };